import request from '../request'

export function getList () {
  return request({
    url: '/data/city.json',
    baseURL: ''
  })
}

export function getHotList () {
  return request({
    url: '/app/carBrand/getHotCity',
    method: 'get'
  })
}
